
import { Component, Vue } from 'vue-property-decorator';

import ManagingAppealProcessPg from '../process/JourneyMap/components/AppRightToAppeal/ManagingAppealProcessPg.vue';
import InstructionWindowFooter from '../process/JourneyMap/components/InstructionWindowFooter.vue';
import PathSidebar from '../process/JourneyMap/components/PathSidebar.vue';

@Component({
    components:{
        ManagingAppealProcessPg,
        InstructionWindowFooter,
        PathSidebar
    }
})
export default class Applications extends Vue { 
    
    showWindow = false;
    windowTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];
    managingAppealProcessContent = false;

    updated=0;

    public adjustHeights(index: number, pathHeight: string) {
        this.updated++;
        this.pathHeights[index] = pathHeight;
    }

    public displayWindow(contentType: string){

        this.managingAppealProcessContent = false;        

        if (contentType == "Make an Application"){

            this.windowTitle = "Make an Application";
            this.pathTypes = ["info", "share", "share", "share", "share", "share", "share", "share", "share", "share", "share"];
            this.pathHeights = ['33rem', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'];
            this.managingAppealProcessContent = true;
        }

        this.showWindow = true;

    }

}

